<template>
    <div class="ltd-card">
        <div class="ltd-lbl">{{ $t('routines.load_type') }}</div>
        <div class="ltd-body" v-if="legend.length">
            <div class="ltd-pie-wrap">
                <div class="ltd-pie-box">
                    <pie-chart :labels="labels" :datasets="datasets" :legend-display="false" disable-hover />
                </div>
            </div>
            <div class="ltd-legend">
                <div class="ltd-leg-row" v-for="seg in legend" :key="seg.label">
                    <div class="ltd-leg-l">
                        <span class="ltd-leg-dot" :style="{ background: seg.color }" />
                        {{ seg.label }}
                    </div>
                    <span class="ltd-leg-pct">{{ seg.pct.toFixed(1) }}%</span>
                </div>
            </div>
        </div>
        <div class="ltd-empty" v-else>{{ $t('common.not_available_short') }}</div>
    </div>
</template>

<script>

import PieChart from '@/components/common/PieChart'

const DONUT_COLORS = ['#339999', '#ccff33', '#66cccc', '#009966', '#8b5cf6', '#f59e0b', '#3b82f6', '#e85c5c']

export default {
    name: 'LoadTypeDonut',
    components: { PieChart },
    props: {
        blocks: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        distribution(vm = this) {
            const labels = []
            vm.blocks.forEach(block => {
                (block.exercises || []).forEach(exercise => {
                    if (exercise.categories) labels.push(...exercise.categories)
                })
            })
            const uniq = [...new Set(labels)]
            const data = uniq.map(label => vm.blocks.reduce((sum, block) =>
                sum + ((block.exercises || []).filter(ex => ex.categories?.includes(label)).length || 0), 0))
            return { labels: uniq, data }
        },
        labels(vm = this) {
            return vm.distribution.labels
        },
        datasets(vm = this) {
            return [{ data: vm.distribution.data, backgroundColor: DONUT_COLORS }]
        },
        legend(vm = this) {
            const total = vm.distribution.data.reduce((a, b) => a + b, 0)
            return vm.distribution.labels.map((label, i) => ({
                label,
                color: DONUT_COLORS[i % DONUT_COLORS.length],
                pct: total ? (vm.distribution.data[i] / total) * 100 : 0,
            }))
        }
    }
}
</script>

<style scoped>
.ltd-card {
    background: var(--v-surface-base);
    border: 1px solid var(--v-outline-base);
    border-radius: 10px;
    padding: 14px 16px;
    display: flex;
    flex-direction: column;
}

.ltd-lbl {
    font-size: 10px;
    font-weight: 700;
    color: var(--v-txtMuted-base);
    text-transform: uppercase;
    letter-spacing: .06em;
    margin-bottom: 12px;
    flex-shrink: 0;
}

.ltd-body {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 16px;
}

.ltd-pie-wrap {
    flex: 1 1 0;
    min-width: 0;
    display: flex;
    align-items: center;
    justify-content: center;
}

.ltd-pie-box {
    width: 100%;
    max-width: 200px;
    aspect-ratio: 1;
}

.ltd-legend {
    display: flex;
    flex-direction: column;
    gap: 8px;
    flex: 1 1 0;
    min-width: 0;
    justify-content: center;
}

.ltd-leg-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.ltd-leg-l {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 12px;
    color: var(--v-txtSecondary-base);
    font-weight: 500;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.ltd-leg-dot {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    flex-shrink: 0;
}

.ltd-leg-pct {
    font-size: 13px;
    font-weight: 700;
    color: var(--v-txtPrimary-base);
    flex-shrink: 0;
}

.ltd-empty {
    font-size: 12px;
    color: var(--v-txtMuted-base);
}

@media (max-width: 600px) {
    .ltd-body {
        flex-direction: column;
        align-items: stretch;
    }

    .ltd-pie-wrap {
        width: 100%;
    }

    .ltd-pie-box {
        max-width: 160px;
    }

    .ltd-legend {
        flex: none;
    }
}
</style>
